import { useNavigate } from "react-router-dom";
import { Avatar, } from "../../../../../../components/common";
import { BreifCaseIconWhite } from "../../../../../../theme/icons2";
import { generateBGColorClassName } from "../../../../../../utils/randomColor";
import React from "react";

export const NameComponent = React.memo((params) => {
    const { data: { client: { url = "" } = {} } = {}, closeModal = () => null } = params;
    const { rowIndex } = params
    const navigate = useNavigate();

    const onClientView = () => {
        navigate(`/greytHR-support?client_url=${url}`);
        closeModal()
    }

    return (
        <div className="flex h-full items-center">
            <div className="flex items-center mr-3">
                <Avatar alt={params.data?.name} className={`${generateBGColorClassName(rowIndex)}`}
                    src={<BreifCaseIconWhite className="m-auto h-[20px] w-[20px] flex justify-center items-center" />} />

            </div>
            <div className="flex flex-col truncate">
                <span role='button' onClick={onClientView} className="text-base font-normal hover:underline text-secondary-500 truncate  ">{params.data?.name}</span>
            </div>
        </div>
    )
})
